import { useCallback, useState } from "react";

const STORAGE_KEY = "wave.favorites.waveIds";

function loadFavoriteWaveIds(): Set<string> {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return new Set();
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return new Set();
    return new Set(parsed.filter((id): id is string => typeof id === "string"));
  } catch {
    return new Set();
  }
}

function persistFavoriteWaveIds(waveIds: Set<string>): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify([...waveIds]));
}

export function useWaveFavorites() {
  const [waveIds, setWaveIds] = useState<Set<string>>(loadFavoriteWaveIds);

  const toggle = useCallback((waveId: string) => {
    setWaveIds((prev) => {
      const next = new Set(prev);
      if (next.has(waveId)) {
        next.delete(waveId);
      } else {
        next.add(waveId);
      }
      persistFavoriteWaveIds(next);
      return next;
    });
  }, []);

  const contains = useCallback((waveId: string) => waveIds.has(waveId), [waveIds]);

  return { waveIds, toggle, contains };
}
